import { Link } from "react-router-dom"
import { format, parseISO } from "date-fns"
import { Sparkles } from "lucide-react"
import { cn } from "@/lib/utils"
import { cleanStyle, cleanerFirstName } from "~/lib/calendar"
import routes from "~/routes"

function windowLabel(clean) {
  if (!clean.window_starts_on || !clean.window_ends_on || clean.window_starts_on === clean.window_ends_on) return ""
  return ` · window ${format(parseISO(clean.window_starts_on), "d MMM")}–${format(parseISO(clean.window_ends_on), "d MMM")}`
}

// A small chip for one clean: cleaner's first name, coloured by status
// (pending amber, accepted green, done grey, flagged red). Links to the cleans
// page where it can be reassigned.
export default function CleanBadge({ clean, className }) {
  const title = `${clean.cleaner_name || "Unassigned"} — ${clean.status}${clean.flagged_reason ? ` (${clean.flagged_reason})` : ""}${windowLabel(clean)}`

  return (
    <Link
      to={routes.cleans}
      title={title}
      className={cn(
        "flex items-center gap-0.5 truncate rounded border px-1 py-0.5 text-[10px] leading-none font-medium hover:opacity-80",
        cleanStyle(clean),
        className,
      )}
    >
      <Sparkles size={9} className="shrink-0" />
      <span className="truncate">{cleanerFirstName(clean)}</span>
    </Link>
  )
}
